module.exports = __webpack_public_path__ + "img/norge.2b52339f.jpg";